import { createContext, useContext, useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentContext = createContext({
  destinations: [],
  packages: [],
  journal: [],
  reviews: [],
  settings: { featuredDestinations: [], featuredPackages: [] },
  loaded: false,
  refresh: () => {},
});

export function ContentProvider({ children }) {
  const [state, setState] = useState({ destinations: [], packages: [], journal: [], reviews: [], settings: { featuredDestinations: [], featuredPackages: [] }, loaded: false });

  const refresh = useCallback(async () => {
    try {
      const [d, p, j, r, s] = await Promise.all([
        axios.get(`${API}/content/destinations`),
        axios.get(`${API}/content/packages`),
        axios.get(`${API}/content/journal`),
        axios.get(`${API}/content/reviews`),
        axios.get(`${API}/settings/homepage`),
      ]);
      setState({ destinations: d.data, packages: p.data, journal: j.data, reviews: r.data, settings: s.data, loaded: true });
    } catch (e) {
      setState((prev) => ({ ...prev, loaded: true }));
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <ContentContext.Provider value={{ ...state, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useCms = () => useContext(ContentContext);
